import React, { useState } from 'react'
import { Checkbox, Drawer, Dropdown, Menu } from 'antd'
import { useSnackbar } from 'notistack'
import Select from 'react-select'
import { AiOutlineDown } from 'react-icons/ai'

import { usePet, useToggle, notifOps } from '../../modules'

import Modal from "../reusable/modal"
import Permissions from '../modals/permissions'
import EditPermissions from '../modals/editPermissions'
import pluralize from 'pluralize'
import { roles } from '../../permissions'

const MergeSuppliers = ({ selected, toggle, visible, onPerform }) => {
    const [main, setMain] = useState(undefined)

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif(`Suppliers have been merged into ${data.name}`, ops('success'))
        
        setTimeout(close, 300)
    }

    const select = i => setMain(main === i ? undefined : i)

    const [{ loading }, execute] = usePet('mergeSuppliers', {
        main,
        suppliers: selected.map(supp => supp._id)
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading || isNaN(main) } onClick={ execute } className="text-white hisani-btn-orange-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
                    <button onClick={ close } className="text-white bg-gray-500 ml-3 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">Merge Suppliers</p>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <div className="flex flex-wrap mt-3 -mx-3">
                        <p></p>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Merged Supplier
                            </label>
                            <div className={ `appearance-none block w-full bg-gray-200 ${ main ? 'text-gray-700' : 'text-gray-400' } border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white` }>
                                { main ? selected[main]?.name : 'Not Supplier Selected' }
                            </div>
                            <p className="text-gray-500 text-xs italic">Select the supplier to merge all selected suppliers into</p>
                        </div>
                    </div>
                    <br />
                    {
                        selected?.length > 0 ?
                            <table className="table-auto w-full">
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Select</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Supplier</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Contact</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        selected.map((supplier, key) => 
                                            <tr>
                                                <td className="p-2">
                                                    <div className="font-semibold text-center">
                                                        <input
                                                            onChange={() => select(key)}
                                                            checked={ main === key }
                                                            type="checkbox"
                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ supplier.name }</div>
                                                    <p className="mb-0 text-gray-400 text-xs italic">{ supplier?.phones.join(', ') }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{supplier?.contactPerson?.name}</div>
                                                    { supplier?.contactPerson?.phone && <p className="mb-0 text-gray-400 text-xs italic">{ supplier?.contactPerson?.phone }</p> }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        : 
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No suppliers selected</p>
                            </div>
                    }

                </div>
            </div>
        </Drawer>
    )
}

export default MergeSuppliers